<template>
  <div class="h-screen">
    <loading-screen v-if="isLoading" />
    <div class="h-full" v-else>
      <router-view v-if="msTeamsAppInitialized" />
      <div v-else>
        {{ $i18nPresenter.t("This route only supported in Microsoft Teams") }}
      </div>
    </div>
  </div>
</template>

<script>

import * as Sentry from '@sentry/vue'
import LoadingScreen from './MSTeamsLoading.vue'

export default {
  components: { LoadingScreen },
  data() {
    return {
      isLoading: true,
      msTeamsAppInitialized: false,
    }
  },
  async mounted() {
    try {
      setTimeout(() => {
        this.isLoading = false
        this.msTeamsAppInitialized = true
      }, 400)
    } catch (e) {
      Sentry.captureException(e)
    }
  },
}
</script>
